<template>
  <v-app id="backGND">
    <navBar />
    <div id="triangle_down">
      <div id="triangle">
        <h1
          class="rotate"
          style="
            margin: auto;
            text-align: left;
            font-family: 'Poiret One', sans-serif;
            color: white;
            padding-left: 1rem;
            font-size: 3rem;
          "
        >
          En Vivo
        </h1>
      </div>
    </div>

    <div style="margin-bottom: 2em; font-size: 1.2em">
      <span class="error_message"
        ><p>{{ error_message }}</p></span
      >
      <span class="warning_message"
        ><p>{{ warning_message }}</p></span
      >
    </div>

    <div v-if="flag_show_content">
      <v-container>
        <v-card color="rgba(255,0,0,0)">
          <div class="embed-container embed-containervideo">
            <youtube
              class="embed-container2"
              :video-id="videoId"
              player-width="1080"
              player-height="720"
              @playing="playing"
              @ended="ended"
              @paused="paused"
              :player-vars="{ autoplay: 1 }"
            ></youtube>
          </div>
        </v-card>
      </v-container>
      <br />
      <urlComp v-if="$store.state.authModule.role == 'admin'" />
    </div>
  </v-app>
</template>
<script>
import urlComp from "@/components/change_url";
import { db } from "@/main";
import navBar from "@/components/navbar";
import foot from "@/components/footer";
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
import moment from "moment";
export default {
  components: { navBar, foot, urlComp },
  data() {
    return {
      videoId: "",

      parts: [],
      videos_array: [],
      videoPart: "",
      flag_onlyOne: false,
      enableVideo: false,
      warning_message: "",
      error_message: "",
      flag_show_content: true,
    };
  },
  methods: {
    videoChange() {
      let h = this.parts.indexOf(this.videoPart);
      this.videoId = this.videos_array[h];
    },
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      console.log("Reproduciendo...");
    },
    paused(event) {
      console.log("pausado...");
    },
    ended(event) {
      console.log("terminado...");
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
  created: async function () {
    this.videoId = "";
    var its_enabled = false;
    await db
      .collection("stream")
      .doc("url")
      .onSnapshot(async (urlElement) => {
        its_enabled = urlElement.data().enabled;
        console.log("cambio eel eenabled");
        let videoIdd = getIdFromURL(urlElement.data().url_video);
        this.videoId = videoIdd;
        var has_package = false;
        var its_admin = false;

        await db
          .collection("users")
          .doc(this.$store.state.authModule.user.uid)
          .get()
          .then((doc) => {
            if (doc.data().role == "admin") {
              its_admin = true;
            }
            if (false == its_admin && false == its_enabled) {
              this.flag_show_content = false;
              this.error_message = "Stream finalizado, Gracias por ver.";
              consolee.log("aqui se desactivo");
            }

            if (doc.data().packages) {
              has_package = true;

              var package_lenght = doc.data().packages.length;
              var end = doc.data().packages[package_lenght - 1].package_end.toDate();

              var today = new Date();

              var fecha1 = moment(today);
              var fecha2 = moment(end);

              var diff = fecha2.diff(fecha1, "days");

              if (today > end) {
                this.flag_show_content = false;
                this.error_message =
                  "Tu suscripción esta vencida no puedes acceder al contenido.";
              } else if (diff < 5) {
                var day = "0" + end.getDate();
                var month = "0" + (end.getMonth() + 1);
                var year = end.getFullYear();
                var hours = end.getHours();
                var minutes = "0" + end.getMinutes();
                var seconds = "0" + end.getSeconds();

                this.warning_message =
                  "Tu suscripción esta proxima a vencer, vence el día: " +
                  day.substr(-2) +
                  "-" +
                  month.substr(-2) +
                  "-" +
                  year +
                  " a las: " +
                  hours +
                  ":" +
                  minutes.substr(-2) +
                  ":" +
                  seconds.substr(-2);
              }
            } else {
              if (its_admin) {
                this.flag_show_content = true;
                //console.log("no tengo paquetes, pero soy admin");
              } else {
                this.flag_show_content = false;
                this.error_message =
                  "Contrata una suscripción para poder acceder al contenido.";
              }
            }
          });
      });
  },
};
</script>
<style scoped>
.error_message {
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}

.warning_message {
  font-weight: 900;
  font-size: 1.1em;
  color: yellow;
  text-align-last: center;
}
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
.embed-container {
  position: relative !important;
  padding-bottom: 60.25% !important;
  height: 0 !important;
  overflow: hidden !important;
}
.embed-container2 {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.embed-containervideo {
  position: relative !important;
  padding-bottom: 60.22% !important;
  height: 0 !important;
  overflow: hidden !important;
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}

#title {
  font-size: 50px;
  font-family: "Times, Times New Roman, serif";
  color: white;
  text-shadow: 0px 0px 30px #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/streampage.vue